// VEPC Gestão — Tela Oficial de Login Administrativo do Proprietário (Firebase Auth)
import { loginProprietarioFirebase, logoutProprietarioFirebase } from '../firebase.js';
import { api, state } from '../api.js';

export function renderLoginAdmin(mensagemErroInicial = null) {
  const container = document.createElement('div');
  container.className = 'onboarding-wrapper';
  container.style.cssText = 'min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #0B0F19; padding: 20px;';

  container.innerHTML = `
    <div class="onboarding-card" style="max-width: 440px; width: 100%; background: #111827; border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 16px; padding: 32px; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);">
      <div style="text-align: center; margin-bottom: 28px;">
        <div style="width: 56px; height: 56px; margin: 0 auto 16px; background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%); border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 26px; font-weight: 800; color: #111827; box-shadow: 0 10px 15px -3px rgba(245, 158, 11, 0.3);">
          V
        </div>
        <h2 style="font-size: 22px; font-weight: 700; color: #F9FAFB; margin: 0 0 6px 0;">VEPC Gestão</h2>
        <div style="font-size: 13px; color: #9CA3AF; letter-spacing: 0.5px;">CENTRAL ADMINISTRATIVA DO PROPRIETÁRIO</div>
      </div>

      <div style="background: rgba(245, 158, 11, 0.1); border: 1px solid rgba(245, 158, 11, 0.25); border-radius: 8px; padding: 12px 14px; margin-bottom: 24px; display: flex; align-items: center; gap: 10px;">
        <span style="font-size: 18px;">🛡️</span>
        <span style="font-size: 12px; color: #FCD34D; line-height: 1.4;">Acesso restrito ao proprietário da plataforma. Autenticação criptográfica Firebase.</span>
      </div>

      <div id="login-feedback" style="${mensagemErroInicial ? 'display: block;' : 'display: none;'} margin-bottom: 20px; padding: 12px 14px; border-radius: 8px; font-size: 13px; ${mensagemErroInicial ? 'background: rgba(239, 68, 68, 0.15); border: 1px solid rgba(239, 68, 68, 0.3); color: #FCA5A5;' : ''}">
        ${mensagemErroInicial || ''}
      </div>

      <form id="form-admin-login" style="display: flex; flex-direction: column; gap: 18px;">
        <div>
          <label style="display: block; font-size: 13px; font-weight: 500; color: #D1D5DB; margin-bottom: 6px;">E-mail do Proprietário</label>
          <input type="email" id="admin-email" required placeholder="proprietario@vepc.com.br" style="width: 100%; box-sizing: border-box; background: #1F2937; border: 1px solid #374151; border-radius: 8px; padding: 12px 14px; font-size: 14px; color: #F9FAFB; outline: none; transition: border-color 0.2s;" autocomplete="username" />
        </div>

        <div>
          <label style="display: block; font-size: 13px; font-weight: 500; color: #D1D5DB; margin-bottom: 6px;">Senha de Acesso</label>
          <input type="password" id="admin-password" required placeholder="••••••••••••" style="width: 100%; box-sizing: border-box; background: #1F2937; border: 1px solid #374151; border-radius: 8px; padding: 12px 14px; font-size: 14px; color: #F9FAFB; outline: none; transition: border-color 0.2s;" autocomplete="current-password" />
        </div>

        <button type="submit" id="btn-submit-login" style="width: 100%; background: linear-gradient(135deg, #F59E0B 0%, #D97706 100%); color: #111827; border: none; border-radius: 8px; padding: 14px; font-size: 14px; font-weight: 700; cursor: pointer; transition: opacity 0.2s; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); margin-top: 6px;">
          Entrar na Central
        </button>
      </form>

      <div style="margin-top: 24px; text-align: center; font-size: 11px; color: #6B7280;">
        VEPC Soluções Digitais &bull; Sessão Protegida por Token Seguro
      </div>
    </div>
  `;

  const form = container.querySelector('#form-admin-login');
  const emailInput = container.querySelector('#admin-email');
  const passInput = container.querySelector('#admin-password');
  const btnSubmit = container.querySelector('#btn-submit-login');
  const feedback = container.querySelector('#login-feedback');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = emailInput.value.trim();
    const password = passInput.value;

    if (!email || !password) return;

    btnSubmit.disabled = true;
    btnSubmit.style.opacity = '0.6';
    btnSubmit.textContent = 'Autenticando no Firebase...';
    feedback.style.display = 'none';

    try {
      // 1. Autenticação via Firebase Auth
      await loginProprietarioFirebase(email, password);

      // 2. Validação no Servidor Administrativo (GET /api/admin/auth/me)
      btnSubmit.textContent = 'Verificando autorização...';
      const meData = await api.getMe();

      if (!meData.operador || !meData.operador.is_proprietario) {
        await logoutProprietarioFirebase();
        throw new Error('Acesso restrito: Sua conta Firebase não possui papel de proprietário na central VEPC.');
      }

      // 3. Sucesso: Atualizar estado e disparar evento de login concluído
      state.operadorAtivo = {
        id: meData.operador.id,
        nome: meData.operador.nome,
        email: meData.operador.email,
        papel: meData.operador.papel,
        rotulo: 'Proprietário VEPC (Oficial)',
        is_proprietario: true
      };

      window.dispatchEvent(new CustomEvent('vepc:admin_logado', { detail: state.operadorAtivo }));
    } catch (err) {
      let msg = err.message || 'Falha ao autenticar.';
      if (msg.includes('auth/invalid-credential') || msg.includes('auth/wrong-password') || msg.includes('auth/user-not-found')) {
        msg = 'Credenciais inválidas. Verifique o e-mail e a senha.';
      } else if (msg.includes('auth/too-many-requests')) {
        msg = 'Muitas tentativas sem sucesso. Aguarde alguns instantes.';
      }
      feedback.style.display = 'block';
      feedback.style.background = 'rgba(239, 68, 68, 0.15)';
      feedback.style.border = '1px solid rgba(239, 68, 68, 0.3)';
      feedback.style.color = '#FCA5A5';
      feedback.textContent = msg;

      btnSubmit.disabled = false;
      btnSubmit.style.opacity = '1';
      btnSubmit.textContent = 'Entrar na Central';
    }
  });

  return container;
}
